import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { notify, SiaHttpService, SiaTranslatePipe } from '@sia/shared';

@Component({
  selector: 'sia-workflow-upload-files',
  standalone: true,
  imports: [
    CommonModule,
    SiaTranslatePipe,
    MatIcon,
    MatDialogActions,
    MatDialogContent,
    MatDialogClose,
    MatDialogTitle,
    MatButton,
  ],
  templateUrl: './workflow-upload-files.component.html',
  styleUrl: './workflow-upload-files.component.scss',
})
export class WorkflowUploadFileComponent {
  #dialogData = inject(MAT_DIALOG_DATA);
  #dialogRef = inject(MatDialogRef);
  #httpService = inject(SiaHttpService);
  selectedFile: File | null = null;
  isUploading = false;
  isDragOver = false;

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectFile(input.files[0]);
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.selectFile(files[0]);
    }
  }

  private selectFile(file: File): void {
    // File size validation (e.g., max 10MB)
    const maxSize = 10 * 1024 * 1024; // 10MB in bytes
    // if (file.size > maxSize) {
    //   notify(
    //     'Il file è troppo grande. Dimensione massima: 10MB',
    //     2000,
    //     'error',
    //   );
    //   this.selectedFile = null;
    //   return;
    // }

    this.selectedFile = file;
  }

  async uploadFile() {
    if (!this.selectedFile || this.isUploading) {
      return;
    }

    this.isUploading = true;

    try {
      const formData = new FormData();
      formData.append('file', this.selectedFile, this.selectedFile.name);

      const workflowId = this.#dialogData.id;
      await this.#httpService.post(
        `workflow/trigger/${workflowId}/upload/file`,
        formData,
      );

      // Close dialog on successful upload
      this.#dialogRef.close({ success: true, file: this.selectedFile });
      this.closeDialog();
    } catch (error: any) {
      console.log(error);
      notify('Errore durante il caricamento del file', 2000, 'error');
    } finally {
      this.isUploading = false;
    }
  }

  // Helper method to format file size
  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
  }
  closeDialog() {
    this.#dialogRef.close();
  }
}
